import { observer } from 'mobx-react-lite';
import { AppName, Env } from 'src/core/Environment';
import { AgentTasksPage } from 'src/pages/TasksPage/components/AgentTasksPage';
import { BOTasksPage } from 'src/pages/TasksPage/components/BOTasksPage';

export const TasksPage = observer(() => {
    if (Env.appName === AppName.AGENT_PORTAL) {
        return <AgentTasksPage />;
    }

    return <BOTasksPage />;
});
